{
  "language": {
    "name": "Bahasa Melayu"
  },
  "nav": {
    "about": "Tentang",
    "expertise": "Kepakaran",
    "certifications": "Pensijilan",
    "connect": "Hubungi"
  },
  "hero": {
    "badge": "Tersedia untuk Peranan Penjagaan Kesihatan di Singapura",
    "title": "Menghubungkan Kecemerlangan Nordic dengan Hati Asia Tenggara",
    "stats": {
      "certifications": "Pensijilan Disahkan",
      "languages": "Bahasa yang Dituturkan",
      "geriatric": "Fokus Penjagaan Geriatrik"
    },
    "cta": {
      "download": "Muat Turun CV",
      "explore": "Terokai Dua Dunia Saya"
    }
  },
  "worlds": {
    "title": "Dua Dunia Saya",
    "finland": {
      "title": "Finland: Di Mana Saya Dilatih",
      "points": [
        "Pendidikan penjagaan kesihatan berasaskan bukti yang ketat",
        "20+ pensijilan khusus dari Duodecim",
        "Fokus keselamatan pesakit dan peningkatan kualiti",
        "Kemahiran klinikal lanjutan dalam sistem penjagaan kesihatan Finland"
      ]
    },
    "asia": {
      "title": "Asia Tenggara: Di Mana Saya Tergolong",
      "points": [
        "Akar budaya Thai dan nilai keluarga",
        "Pemahaman jangkaan penjagaan kesihatan Asia",
        "Keupayaan komunikasi pelbagai bahasa",
        "Kepekaan budaya dalam penjagaan pesakit"
      ]
    },
    "bridge": {
      "title": "Menghubungkan Kedua-dua Dunia",
      "points": {
        "evidence": {
          "title": "Amalan Berasaskan Bukti",
          "desc": "Latihan Finland bertemu kehangatan Asia"
        },
        "cultural": {
          "title": "Kecerdasan Budaya",
          "desc": "Menavigasi keperluan pesakit yang pelbagai"
        },
        "tech": {
          "title": "Kecemerlangan Teknikal",
          "desc": "Sistem penjagaan kesihatan moden"
        },
        "family": {
          "title": "Penjagaan Berpusatkan Keluarga",
          "desc": "Pendekatan holistik untuk penyembuhan"
        }
      }
    }
  },
  "patient": {
    "title": "Komunikasi Berpusatkan Pesakit",
    "subtitle": "Bagaimana saya menyesuaikan gaya komunikasi untuk memenuhi keperluan pesakit yang pelbagai",
    "conversations": {
      "medication": {
        "patient": "Saya bimbang mengambil begitu banyak ubat. Anak perempuan saya kata terlalu banyak.",
        "nurse": "Saya faham kebimbangan anda. Biar saya terangkan setiap ubat dan mengapa ia penting untuk pemulihan anda. Kita juga boleh berbincang dengan anak perempuan anda dan doktor untuk memastikan semua orang selesa dengan rancangan rawatan."
      },
      "pain": {
        "patient": "Kesakitan semakin teruk, tetapi saya tidak mahu mengganggu sesiapa.",
        "nurse": "Keselesaan anda sangat penting bagi kami. Sila jangan teragak-agak untuk memberitahu kami tentang kesakitan anda. Biar saya nilai tahap kesakitan anda dan kita akan bekerjasama untuk menguruskannya dengan berkesan. Kesejahteraan anda adalah keutamaan kami."
      },
      "family": {
        "patient": "Bolehkah keluarga saya tinggal bersama saya? Saya berasa lebih baik apabila mereka di sini.",
        "nurse": "Sudah tentu. Sokongan keluarga adalah bahagian penting dalam penyembuhan. Mari kita atur masa lawatan yang sesuai untuk semua orang sambil memastikan anda mendapat rehat yang cukup. Kami menghargai penglibatan keluarga anda dalam penjagaan anda."
      }
    }
  },
  "cv": {
    "title": "CURRICULUM VITAE",
    "sections": {
      "personalInfo": "MAKLUMAT PERIBADI",
      "summary": "RINGKASAN PROFESIONAL",
      "licenses": "PENDAFTARAN & KELAYAKAN KEJURURAWATAN",
      "education": "PENDIDIKAN",
      "experience": "PENGALAMAN PROFESIONAL",
      "certifications": "PEMBANGUNAN PROFESIONAL BERTERUSAN",
      "skills": "KEMAHIRAN KLINIKAL",
      "languages": "BAHASA"
    },
    "personalInfo": {
      "fullName": "Nama Penuh",
      "dateOfBirth": "Tarikh Lahir",
      "nationality": "Kewarganegaraan",
      "contact": "Hubungan",
      "email": "E-mel",
      "location": "Lokasi Semasa"
    },
    "summary": "Jururawat Berdaftar yang berdedikasi dengan latihan penjagaan kesihatan Finland dan lesen kejururawatan aktif. Kepakaran dalam pembedahan, psikiatri, penjagaan geriatrik, dan penjagaan kecemasan. Keupayaan terbukti dalam amalan berasaskan bukti, keselamatan pesakit, dan kerjasama multidisiplin. Mencari untuk menyumbang kecemerlangan klinikal dan kebolehsuaian budaya kepada sistem penjagaan kesihatan Singapura.",
    "licenses": {
      "nursing": {
        "title": "Lesen Kejururawatan Finland",
        "details": "Jururawat Berdaftar Berlesen (Sairaanhoitaja) | Nombor Pendaftaran: 10009985648 | Dikeluarkan oleh: Valvira | Status: Aktif"
      },
      "medication": {
        "title": "Lesen Ubat Finland",
        "details": "Jenis Lesen: Love (Lääkkeenmääräämis Lupa hoitajille) | Status: Sah"
      }
    },
    "education": {
      "degree": "Sarjana Muda Penjagaan Kesihatan (Sains Kejururawatan)",
      "institution": "Universiti Sains Gunaan LAB, Lahti, Finland",
      "year": "Tahun Graduasi"
    },
    "experience": {
      "responsibilities": "Tanggungjawab Utama",
      "achievements": "Pencapaian Utama",
      "0": {
        "title": "Pelajar Kejururawatan - Unit Penjagaan Akut",
        "organization": "Hospital Pusat Päijät-Häme",
        "location": "Lahti, Finland",
        "period": "Februari 2025 - April 2025",
        "responsibilities": [
          "Menyediakan penjagaan pesakit komprehensif dalam tetapan penjagaan akut, termasuk pemantauan tanda vital, pentadbiran ubat, dan dokumentasi dalam rekod kesihatan elektronik (LifeCare)",
          "Melakukan prosedur klinikal seperti kanulasi IV, rakaman ECG, dan pelbagai intervensi penjagaan pesakit",
          "Bekerjasama dengan pasukan multidisiplin termasuk doktor, fisioterapis, dan ahli farmasi",
          "Menilai keadaan pesakit, bertindak balas terhadap perubahan tanda vital, dan meningkatkan kebimbangan dengan sewajarnya"
        ]
      },
      "1": {
        "title": "Pelajar Kejururawatan - Dewan Bedah",
        "organization": "Hospital Pusat Etelä-Karjala",
        "location": "Lappeenranta, Finland",
        "period": "Januari 2025 - Februari 2025",
        "responsibilities": [
          "Memperoleh pengalaman komprehensif dalam penjagaan kejururawatan perioperatif merentasi ketiga-tiga peranan: jururawat anestesia, jururawat scrub, dan jururawat peredaran",
          "Membantu dalam prosedur pembedahan sambil mengekalkan teknik aseptik yang ketat dan protokol medan steril",
          "Memantau tanda vital pesakit dan tindak balas anestesia menggunakan peralatan pemantauan canggih"
        ]
      },
      "2": {
        "title": "Jururawat Berdaftar - Wad Pembedahan",
        "organization": "Hospital Pusat Päijät-Häme, Wad R5",
        "location": "Lahti, Finland",
        "period": "Disember 2024 - Februari 2025",
        "responsibilities": [
          "Menyediakan penjagaan kejururawatan pra-operasi dan pasca-operasi yang komprehensif untuk pesakit pembedahan dalam wad penjagaan akut 30 katil",
          "Mentadbir ubat, terapi IV, dan pengurusan kesakitan mengikut arahan doktor dan protokol kejururawatan",
          "Memantau tanda vital pesakit, penyembuhan luka, dan pemulihan pasca pembedahan"
        ],
        "achievements": [
          "Berjaya menguruskan penjagaan untuk pesakit pasca pembedahan berketajaman tinggi yang memerlukan penjagaan luka kompleks",
          "Mengekalkan ketepatan pentadbiran ubat 100% melalui pengesahan dan dokumentasi yang teliti"
        ]
      }
    },
    "certifications": {
      "0": {
        "category": "Psikiatri & Kesihatan Mental",
        "items": [
          "Belia Cemas dan Tidak Dapat Tidur: Perspektif Psikiatri Remaja (55 min) - Nov 2024",
          "Temu Bual Motivasi (60 min) - Dis 2022"
        ]
      },
      "1": {
        "category": "Penjagaan Geriatrik & Warga Emas",
        "items": [
          "Pengenalpastian Kelemahan Geriatrik (30 min) - Okt 2024",
          "Pengurusan Ubat Warga Emas (60 min) - Sept 2024",
          "Polifarmasi pada Warga Emas (40 min) - Sept 2024",
          "Pencegahan Jatuh (60 min) - Sept 2024"
        ]
      },
      "2": {
        "category": "Penjagaan Akut & Kecemasan",
        "items": [
          "Penilaian Kecemasan Pesakit Neurologi (60 min) - Nov 2023",
          "Penilaian Sistematik Fungsi Vital Menggunakan Prinsip ABCDE (30 min) - Okt 2023",
          "Pemasangan dan Penggunaan Kateter Vena Pusat (CVK) (70 min) - Nov 2023"
        ]
      }
    },
    "skills": {
      "clinical": {
        "title": "Kompetensi Penjagaan Pesakit",
        "items": [
          "Penilaian pesakit komprehensif dan pemantauan tanda vital",
          "Penjagaan luka lanjutan dan penukaran pembalut",
          "Pentadbiran ubat (oral, IV, IM, SC)",
          "Kanulasi IV, kateterisasi, dan pengurusan tiub NG",
          "Penilaian dan pengurusan kesakitan",
          "Penjagaan pesakit pra-operasi dan pasca-operasi"
        ]
      },
      "technical": {
        "title": "Sistem Teknikal & Klinikal",
        "items": [
          "Sistem Rekod Kesihatan Elektronik (EHR) LifeCare",
          "Operasi peralatan perubatan (monitor tanda vital, pam infusi, sistem penghantaran oksigen)",
          "Protokol kawalan jangkitan dan teknik steril",
          "Protokol tindak balas kecemasan dan sokongan hayat asas"
        ]
      },
      "soft": {
        "title": "Kemahiran Insaniah & Atribut Profesional",
        "items": [
          "Kemahiran komunikasi dan pendengaran aktif yang cemerlang",
          "Empati yang kuat dan penjagaan berpusatkan pesakit",
          "Kerjasama pasukan yang berkesan dalam tetapan multidisiplin",
          "Pengurusan masa dalam persekitaran tekanan tinggi",
          "Kepekaan budaya dengan populasi pesakit yang pelbagai"
        ]
      }
    },
    "languages": {
      "thai": "Thai",
      "finnish": "Finland",
      "english": "Inggeris"
    },
    "languageProficiency": {
      "native": "Penutur Asli",
      "fluent": "Fasih",
      "professional_b2": "Profesional (B2)"
    },
    "generated": "Dijana"
  },
  "footer": {
    "credentials": "Jururawat Berdaftar, BSc (Kejururawatan)",
    "privacy": "Dasar Privasi",
    "terms": "Terma Penggunaan",
    "copyright": "© {{year}} Mona. Hak cipta terpelihara."
  }
}